export const categories = [
  { id: 'fashion', name: '时尚精品', icon: 'ri-shirt-line', description: '日韩华系顶尖设计师品牌服饰' },
  { id: 'beauty', name: '美妆护肤', icon: 'ri-magic-line', description: '亚洲天然成分与尖端科技护肤' },
  { id: 'home', name: '家居生活', icon: 'ri-home-heart-line', description: '融合东方美学与现代设计的家居' },
  { id: 'lifestyle', name: '生活好物', icon: 'ri-gift-line', description: '提升日常品质的精致小物' },
];

export const products = [
  {
    id: 1,
    name: '京都匠人手工陶瓷茶具套装',
    category: 'home',
    price: 2880,
    originalPrice: 3600,
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20handcrafted%20Japanese%20Kyoto%20ceramic%20tea%20set%20with%20delicate%20glaze%20on%20a%20minimalist%20wooden%20tray%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20product%20photography%2C%20zen%20aesthetic%2C%20high%20detail&width=600&height=600&seq=product-kyoto-tea&orientation=squarish',
    brand: '京都陶芸',
    region: '日本',
    rating: 4.9,
    reviews: 128,
    tags: ['手工', '限量', '匠人'],
    badge: '人气爆款',
  },
  {
    id: 2,
    name: '首尔设计师极简真丝围巾',
    category: 'fashion',
    price: 1280,
    originalPrice: 1600,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20minimalist%20pure%20silk%20scarf%20designed%20in%20Seoul%20with%20subtle%20geometric%20pattern%2C%20draped%20elegantly%20on%20a%20clean%20cream%20background%2C%20soft%20diffused%20lighting%2C%20product%20photography%2C%20Korean%20design%20aesthetic&width=600&height=600&seq=product-seoul-scarf&orientation=squarish',
    brand: 'Seoul Atelier',
    region: '韩国',
    rating: 4.8,
    reviews: 96,
    tags: ['真丝', '设计师款'],
    badge: '新品',
  },
  {
    id: 3,
    name: '济州岛天然绿茶护肤精华',
    category: 'beauty',
    price: 680,
    originalPrice: 850,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20green%20tea%20skincare%20serum%20bottle%20from%20Jeju%20Island%20with%20natural%20botanical%20elements%2C%20minimalist%20glass%20packaging%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20premium%20beauty%20product%20photography&width=600&height=600&seq=product-jeju-serum&orientation=squarish',
    brand: '济州自然',
    region: '韩国',
    rating: 4.7,
    reviews: 256,
    tags: ['天然', '有机', '敏感肌'],
    badge: '口碑推荐',
  },
  {
    id: 4,
    name: '上海新中式真丝刺绣睡衣',
    category: 'fashion',
    price: 1680,
    originalPrice: 2100,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20Chinese%20style%20silk%20pajama%20with%20delicate%20hand%20embroidery%2C%20soft%20pearl%20white%20fabric%2C%20displayed%20on%20a%20minimalist%20hanger%2C%20clean%20cream%20background%2C%20luxurious%20product%20photography&width=600&height=600&seq=product-shanghai-pajama&orientation=squarish',
    brand: '上海绮罗',
    region: '中国',
    rating: 4.9,
    reviews: 89,
    tags: ['真丝', '刺绣', '限定'],
    badge: '限定款',
  },
  {
    id: 5,
    name: '曼谷手工藤编家居收纳篮',
    category: 'home',
    price: 580,
    originalPrice: 720,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20handwoven%20rattan%20storage%20basket%20from%20Bangkok%20artisans%2C%20natural%20fiber%20texture%2C%20minimalist%20home%20decor%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20sustainable%20craft%20product%20photography&width=600&height=600&seq=product-bangkok-basket&orientation=squarish',
    brand: '曼谷藤语',
    region: '泰国',
    rating: 4.6,
    reviews: 183,
    tags: ['手工', '环保', '天然'],
    badge: '',
  },
  {
    id: 6,
    name: '东京银座高端美白面膜套装',
    category: 'beauty',
    price: 980,
    originalPrice: 1200,
    image: 'https://readdy.ai/api/search-image?query=Premium%20Japanese%20whitening%20facial%20mask%20set%20from%20Ginza%20Tokyo%20in%20elegant%20minimalist%20packaging%2C%20clean%20cream%20background%2C%20soft%20lighting%2C%20high-end%20beauty%20product%20photography%2C%20luxurious%20skincare&width=600&height=600&seq=product-tokyo-mask&orientation=squarish',
    brand: '银座美研',
    region: '日本',
    rating: 4.8,
    reviews: 312,
    tags: ['美白', '高效', '院线级'],
    badge: '销量冠军',
  },
  {
    id: 7,
    name: '新加坡设计师香薰蜡烛礼盒',
    category: 'lifestyle',
    price: 420,
    originalPrice: 520,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20designer%20scented%20candle%20gift%20box%20from%20Singapore%20with%20tropical%20botanical%20fragrance%2C%20minimalist%20ceramic%20container%2C%20clean%20cream%20background%2C%20soft%20warm%20lighting%2C%20premium%20lifestyle%20product%20photography&width=600&height=600&seq=product-sg-candle&orientation=squarish',
    brand: '狮城香韵',
    region: '新加坡',
    rating: 4.5,
    reviews: 67,
    tags: ['香薰', '礼盒', '设计师'],
    badge: '',
  },
  {
    id: 8,
    name: '台北文创设计陶瓷杯具套装',
    category: 'lifestyle',
    price: 360,
    originalPrice: 450,
    image: 'https://readdy.ai/api/search-image?query=Creative%20Taiwanese%20designer%20ceramic%20cup%20set%20with%20cultural%20patterns%2C%20minimalist%20modern%20style%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20artisan%20product%20photography%2C%20elegant%20tableware&width=600&height=600&seq=product-taipei-cup&orientation=squarish',
    brand: '台北文创',
    region: '中国台湾',
    rating: 4.7,
    reviews: 145,
    tags: ['文创', '设计', '送礼'],
    badge: '文创精选',
  },
  {
    id: 9,
    name: '首尔江南轻奢链条手提包',
    category: 'fashion',
    price: 2680,
    originalPrice: 3350,
    image: 'https://readdy.ai/api/search-image?query=Chic%20light%20luxury%20chain%20handbag%20from%20Gangnam%20Seoul%20designer%2C%20minimalist%20elegant%20design%2C%20neutral%20cream%20leather%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20fashion%20product%20photography%2C%20Korean%20aesthetic&width=600&height=600&seq=product-seoul-bag&orientation=squarish',
    brand: '江南设计',
    region: '韩国',
    rating: 4.8,
    reviews: 201,
    tags: ['轻奢', '设计师', '百搭'],
    badge: '明星同款',
  },
  {
    id: 10,
    name: '北海道薰衣草舒缓沐浴套装',
    category: 'beauty',
    price: 520,
    originalPrice: 650,
    image: 'https://readdy.ai/api/search-image?query=Relaxing%20lavender%20bath%20set%20from%20Hokkaido%20Japan%20in%20minimalist%20glass%20bottles%2C%20dried%20lavender%20stems%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20spa%20product%20photography%2C%20premium%20wellness&width=600&height=600&seq=product-hokkaido-bath&orientation=squarish',
    brand: '北海道自然',
    region: '日本',
    rating: 4.6,
    reviews: 178,
    tags: ['天然', '舒缓', '植物'],
    badge: '',
  },
  {
    id: 11,
    name: '河内手工刺绣丝绒靠垫',
    category: 'home',
    price: 380,
    originalPrice: 480,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20hand%20embroidered%20velvet%20cushion%20from%20Hanoi%20Vietnam%20with%20intricate%20gold%20thread%20patterns%2C%20rich%20texture%2C%20clean%20cream%20background%2C%20soft%20warm%20lighting%2C%20artisan%20home%20decor%20product%20photography&width=600&height=600&seq=product-hanoi-pillow&orientation=squarish',
    brand: '河内绣坊',
    region: '越南',
    rating: 4.5,
    reviews: 54,
    tags: ['手工', '刺绣', '东南亚'],
    badge: '',
  },
  {
    id: 12,
    name: '京都宇治抹茶高端礼盒',
    category: 'lifestyle',
    price: 880,
    originalPrice: 1100,
    image: 'https://readdy.ai/api/search-image?query=Premium%20Uji%20Kyoto%20matcha%20green%20tea%20gift%20box%20in%20elegant%20wooden%20packaging%2C%20traditional%20Japanese%20design%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20luxurious%20food%20product%20photography&width=600&height=600&seq=product-uji-matcha&orientation=squarish',
    brand: '宇治茶道',
    region: '日本',
    rating: 4.9,
    reviews: 423,
    tags: ['抹茶', '礼盒', '京都'],
    badge: '顶级推荐',
  },
];